import { GET_EXPENSES_SUCCESS, GET_EXPENSES_FAILURE, GET_EXPENSES_PENDING } from "./actionTypes";

const initialState = {
  expenses: [],
  count: 0,
  loading: true,
  failed: false,
  error: {},
};

function expensesReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_EXPENSES_PENDING: 
      return { ...state , loading : true };

    case GET_EXPENSES_SUCCESS:
      return {
        ...state,
        expenses: payload.list,
        count: payload.count,
        failed: false,
        loading: false,
      };

    case GET_EXPENSES_FAILURE:
      return { ...state, failed: true, loading: false, error: payload.error };

    default:
      return state;
  }
}

export default expensesReducer;
